import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SessaoUtil } from '../../../util/sessao-util';
import { Router } from '@angular/router';
import { UtilService } from '../../../util/util.service';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { SharedComponent } from '../shared.component';

declare var $: any;
declare var moment: any;

@Component({
  selector: 'ats-datatables',
  templateUrl: './tabeladatatables.component.html',
  styleUrls: ['./tabeladatatables.component.css']
})
export class TabelaDataTablesComponent extends SharedComponent implements OnInit {

  @Input() idTabela: string;
  @Input() classTable: string;
  @Input() urlAjax: string;
  @Input() botaoIncluir: any = {};
  @Input() botoesAdicionais: Array<any>;
  @Input() placeholderPesquisa: string;
  @Input() colunasDenificoes: Array<any>;
  @Input() ordem: Array<any>;
  @Input() mostraPaginacao: Boolean;
  @Input() mostraInformacao: Boolean;
  @Input() mostraPesquisa: Boolean;
  @Input() mostraQuantidadePorPagina: Boolean;
  @Input() ocultaPanel: Boolean;
  @Input() callBackConsultar: Function;
  @Input() callBackAlterar: Function;
  @Input() callBackExcluir: Function;
  @Input() callBackAtivo: Function;
  @Input() callBackBloqueio: Function;
  @Input() parametrosAdicionais: any = {};
  @Input() filtroSomenteAtivos: Boolean;

  table: any;
  somenteAtivas: boolean = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessaoUtil: SessaoUtil,
    private toasterUtil: ToasterUtilService
  ) {
    super(route, sessaoUtil);
  }

  colunas: Array<string>;
  columnDefs: Array<any>;
  order: Array<Array<any>>;
  FORMATO_OPCAO: any;

  FORMATO_OPCAO_CONSULTA_ALTERACAO: any;

  FORMATO_ATIVO: any;

  FORMATO_BLOQUEADO: any;

  FORMATO_DINHEIRO: any = function (data, type, row, meta) {
    return 'R$' + $.ats._number_format(data, 2);
  };

  FORMATO_PERCENTUAL: any = function (data, type, row, meta) {
    return $.ats._number_format(data, 2) + ' %';
  };

  FORMATO_NUMERO_2: any = function (data, type, row, meta) {
    return $.ats._number_format(data, 2);
  };

  FORMATO_NUMERO_3: any = function (data, type, row, meta) {
    return $.ats._number_format(data, 3);
  };

  FORMATO_DATA: any = function (data, type, row, meta) {
    return new moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
  };

  FORMATO_DATA_HORA: any = function (data, type, row, meta) {
    return new moment(data, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
  };

  FORMATO_LPAD6: any = function (data, type, row, meta) {
    return $.ats._lpad(data, 6, "0");
  };

  ngOnInit() {
    var self = this;

    self.FORMATO_OPCAO = function (data, type, row, meta) {
      let retorno: string = '';

      if(self.getPodeConsultar()){
        retorno += "<button type='button' title='Consultar' data-row='" + JSON.stringify({'id': row.id}) + "' class='btn btn-xs btn-outline btn-default btn-consultar'><i class='fa fa-eye'></i></button>";
      }else{
        retorno += "<button type='button' title='Consultar' disabled='disabled' class='btn btn-xs btn-outline btn-default'><i class='fa fa-eye'></i></button>";
      }

      if(self.getPodeAlterar()){
        retorno += " <button type='button' title='Alterar' data-row='" + JSON.stringify({'id': row.id}) + "' class='btn btn-xs btn-outline btn-info btn-alterar'><i class='fa fa-edit'></i></button>";
      }else{
        retorno += " <button type='button' title='Alterar' disabled='disabled' class='btn btn-xs btn-outline btn-info'><i class='fa fa-edit'></i></button>";
      }

      if(self.getPodeExcluir()){
        retorno += " <button type='button' title='Excluir' data-row='" + JSON.stringify({'id': row.id}) + "' class='btn btn-xs btn-outline btn-danger btn-excluir'><i class='fa fa-times'></i></button>";
      }else{
        retorno += " <button type='button' title='Excluir' disabled='disabled' class='btn btn-xs btn-outline btn-danger'><i class='fa fa-times'></i></button>";
      }

      return retorno;
    };

    self.FORMATO_OPCAO_CONSULTA_ALTERACAO = function (data, type, row, meta) {
      let retorno: string = '';

      if(self.getPodeConsultar()){
        retorno += "<button type='button' title='Consultar' data-row='" + JSON.stringify({'id': row.id}) + "' class='btn btn-xs btn-outline btn-default btn-consultar'><i class='fa fa-eye'></i></button>";
      }else{
        retorno += "<button type='button' title='Consultar' disabled='disabled' class='btn btn-xs btn-outline btn-default'><i class='fa fa-eye'></i></button>";
      }

      if(self.getPodeAlterar()){
        retorno += " <button type='button' title='Alterar' data-row='" + JSON.stringify({'id': row.id}) + "' class='btn btn-xs btn-outline btn-info btn-alterar'><i class='fa fa-edit'></i></button>";
      }else{
        retorno += " <button type='button' title='Alterar' disabled='disabled' class='btn btn-xs btn-outline btn-info'><i class='fa fa-edit'></i></button>";
      }

      return retorno;
    };


    self.FORMATO_ATIVO = function (data, type, row, meta) {
      let retorno: string = '';

      if(self.getPodeAlterar()){
        retorno = "<label class='switch'>"+
                  "  <input type='checkbox' class='checkbox-ativo' " + (data != null && data ? "checked='ckecked'" : "")+ " data-id='"+row.id+"'>"+
                  "  <span></span>"+
                  "</label>";
      }else{
        retorno = data ? "<span class='label label-success'>Sim</span>" : "<span class='label label-danger'>Não</span>";
      }

      return retorno;
    };

    self.FORMATO_BLOQUEADO = function (data, type, row, meta) {
      let retorno: string = '';

      if(self.getPodeAlterar()){
        retorno = "<label class='switch'>"+
                  "  <input type='checkbox' class='checkbox-bloqueado' " + (data != null && data ? "checked='ckecked'" : "")+ " data-id='"+row.id+"'>"+
                  "  <span></span>"+
                  "</label>";
      }else{
        retorno = !data ? "<span class='label label-success'>Não</span>" : "<span class='label label-danger'>Sim</span>";
      }

      return retorno;
    };

    if(UtilService.empty(self.botaoIncluir)){
      self.botaoIncluir = {label: '',
                           url: '',
                           className: '',
                           icon: '',
                           visible: false};
    }else{
      if(UtilService.empty(self.botaoIncluir.className)){
        self.botaoIncluir.className = 'btn btn-labeled btn-info';
      }

      if(UtilService.empty(self.botaoIncluir.icon)){
        self.botaoIncluir.icon = 'fa fa-plus';
      }

      if(self.botaoIncluir.visible == undefined || self.botaoIncluir.visible == null){
        self.botaoIncluir.visible = false;
      }

      if(UtilService.empty(self.botaoIncluir.label)){
        self.botaoIncluir.label = 'Incluir';
      }

      if(UtilService.empty(self.botaoIncluir.url)){
        self.botaoIncluir.url = '#';
      }

    }

    if ($.ats._empty(self.mostraPaginacao)) {
      self.mostraPaginacao = true;
    }

    if ($.ats._empty(self.mostraInformacao)) {
      self.mostraInformacao = true;
    }

    if ($.ats._empty(self.mostraPesquisa)) {
      self.mostraPesquisa = true;
    }

    if ($.ats._empty(self.mostraQuantidadePorPagina)) {
      self.mostraQuantidadePorPagina = true;
    }

    if (UtilService.empty(self.placeholderPesquisa)) {
      self.placeholderPesquisa = 'Digite aqui sua pesquisa...';
    }


    if (!$.ats._empty(self.ordem)) {
      self.order = [];
      var itemOrdem = [];

      for (var i = 0; i < self.ordem.length; i++) {
        var index = $.ats._indexOfArrayObject(self.colunasDenificoes, 'campo', self.ordem[i].campo);
        itemOrdem = [];

        if (index != -1) {
          itemOrdem = [index, self.ordem[i].tipoOrdem];
          self.order.push(itemOrdem);
        }
      }

      if (self.order.length <= 0) {
        self.order = [[0, 'asc']];
      }
    } else {
      self.order = [[0, 'asc']];
    }

    if (!$.ats._empty(self.colunasDenificoes)) {

      self.columnDefs = [];
      self.colunas = [];

      for (var i = 0; i < self.colunasDenificoes.length; i++) {
        var col = new Object();

        col['targets'] = i;

        if (!$.ats._empty(self.colunasDenificoes[i].campo)) {
          col['data'] = self.colunasDenificoes[i].campo;
        } else {
          col['data'] = i;
        }

        if (!$.ats._empty(self.colunasDenificoes[i].className)) {
          col['className'] = self.colunasDenificoes[i].className;
        }

        if (!$.ats._empty(self.colunasDenificoes[i].nomeColuna)) {
          self.colunas.push(self.colunasDenificoes[i].nomeColuna);
        } else {
          self.colunas.push('');
        }

        if (self.colunasDenificoes[i].largura != undefined && self.colunasDenificoes[i].largura != null) {
          col['width'] = self.colunasDenificoes[i].largura;
        }

        if (self.colunasDenificoes[i].width != undefined && self.colunasDenificoes[i].width != null) {
          col['width'] = self.colunasDenificoes[i].width;
        }

        if(self.colunasDenificoes[i].ordenavel != undefined && self.colunasDenificoes[i].ordenavel != null){
          col['orderable'] = self.colunasDenificoes[i].ordenavel;
        }

        if (self.colunasDenificoes[i].render != undefined && self.colunasDenificoes[i].render != null) {
          col['render'] = self.colunasDenificoes[i].render;
        }

        if (!$.ats._empty(self.colunasDenificoes[i].formato)) {
          if (self.colunasDenificoes[i].formato == 'lpad6') {
            col['render'] = this.FORMATO_LPAD6;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center';
            }else{
              col['className'] = ' text-center';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 70;
            }
          }

          if (self.colunasDenificoes[i].formato == 'data') {
            col['render'] = this.FORMATO_DATA;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center';
            }else{
              col['className'] = ' text-center';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 80;
            }

          }

          if (self.colunasDenificoes[i].formato == 'datahora') {
            col['render'] = this.FORMATO_DATA_HORA;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center';
            }else{
              col['className'] = ' text-center';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 130;
            }
          }

          if (self.colunasDenificoes[i].formato == 'dinheiro') {
            col['render'] = this.FORMATO_DINHEIRO;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-right';
            }else{
              col['className'] = ' text-right';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 120;
            }
          }

          if (self.colunasDenificoes[i].formato == 'percentual') {
            col['render'] = this.FORMATO_PERCENTUAL;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-right';
            }else{
              col['className'] = ' text-right';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 120;
            }
          }

          if (self.colunasDenificoes[i].formato == 'numero2') {
            col['render'] = this.FORMATO_NUMERO_2;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-right';
            }else{
              col['className'] = ' text-right';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 120;
            }
          }

          if (self.colunasDenificoes[i].formato == 'numero3') {
            col['render'] = this.FORMATO_NUMERO_3;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-right';
            }else{
              col['className'] = ' text-right';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 120;
            }
          }

          if (self.colunasDenificoes[i].formato == 'ativo') {
            col['render'] = this.FORMATO_ATIVO;
            col['responsivePriority'] = 2;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center';
            }else{
              col['className'] = ' text-center';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 70;
            }
          }

          if (self.colunasDenificoes[i].formato == 'bloqueado') {
            col['render'] = this.FORMATO_BLOQUEADO;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center';
            }else{
              col['className'] = ' text-center';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 70;
            }
          }


          if (self.colunasDenificoes[i].formato == 'opcao') {
            col['render'] = this.FORMATO_OPCAO;
            col['responsivePriority'] = 1;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center text-nowrap';
            }else{
              col['className'] = ' text-center text-nowrap';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 90;
            }

            col['orderable'] = false;
          }

          if (self.colunasDenificoes[i].formato == 'opcao-consulta-alteracao') {
            col['render'] = this.FORMATO_OPCAO_CONSULTA_ALTERACAO;
            col['responsivePriority'] = 1;

            if($.ats._empty(col['className'])){
              col['className'] = 'text-center text-nowrap';
            }else{
              col['className'] = ' text-center text-nowrap';
            }

            if($.ats._empty(col['width'])){
              col['width'] = 50;
            }

            col['orderable'] = false;
          }

        }
        self.columnDefs.push(col);
      }

    }

    if (self.filtroSomenteAtivos) {
      if ($.ats._empty(self.parametrosAdicionais)) {
        self.parametrosAdicionais = {};
      }
      self.parametrosAdicionais.somenteAtivas = self.somenteAtivas;
    }

    $(document).ready(function () {

      $(document).on("preInit.dt", function(){
        $('.dataTables_filter input[type="search"]').attr('maxlength', 80);
      });

      self.table = $('#' + self.idTabela).DataTable({
        bAutoWidth: true,
        paging: self.mostraPaginacao,
        searching: self.mostraPesquisa,
        info: self.mostraInformacao,
        lengthChange: self.mostraQuantidadePorPagina,
        dom: $.ats._dataTableDom(),
        lengthMenu: [[10, 25, 50], [10, 25, 50]],
        order: self.order,
        sPaginationType: 'simple_numbers',
        columnDefs: self.columnDefs,
        language: $.ats._dataTableLanguage(self.placeholderPesquisa),
        bServerSide: true,
        sAjaxSource: UtilService.getUrl() + self.urlAjax + '/paginate',
        sServerMethod: "POST",
        fnServerData: function(sSource, aoData, fnCallback){
          $.ats._datatablesServerData(sSource, aoData, fnCallback, self.table, self.sessaoUtil.getToken().access_token, self.toasterUtil);
        },
        fnServerParams : function(aoData) {

          if(!$.ats._empty(self.parametrosAdicionais)){
            aoData.push({'name' : 'parametrosAdicionais','value' : JSON.stringify(self.parametrosAdicionais)});
          }
        }

      });

      if(self.filtroSomenteAtivos){
        var toggleHtml = "<div class='filtro-somente-ativos'>"+
                         "  <span class='filtro-somente-ativos-texto'>Filtrar somente empresas ativas</span>"+
                         "  <label class='switch'>"+
                         "    <input type='checkbox' class='checkbox-somente-ativos' " + (self.somenteAtivas ? "checked='checked'" : "") + ">"+
                         "    <span></span>"+
                         "  </label>"+
                         "</div>";

        $('#' + self.idTabela + '_wrapper').find('.dataTables_filter').prepend(toggleHtml);

        $('#' + self.idTabela + '_wrapper').on('change', 'input.checkbox-somente-ativos', function () {
          self.somenteAtivas = this.checked;

          if($.ats._empty(self.parametrosAdicionais)){
            self.parametrosAdicionais = {};
          }
          self.parametrosAdicionais.somenteAtivas = self.somenteAtivas;

          if(self.table){
            self.table.ajax.reload(null, false);
          }
        });
      }

      if(self.getPodeConsultar()){
        $('#' + self.idTabela).on('click', 'button.btn-consultar', function (e) {
          self.callBackConsultar($(this).data('row'));
        });
      }

      if(self.getPodeAlterar()){
        $('#' + self.idTabela).on('click', 'button.btn-alterar', function (e) {
          self.callBackAlterar($(this).data('row'));
        });
      }

      if(self.getPodeExcluir()){
        $('#' + self.idTabela).on('click', 'button.btn-excluir', function (e) {
          self.callBackExcluir($(this).data('row'));
        });
      }

      if(self.getPodeAlterar()){
        $('#' + self.idTabela).on('click', 'input.checkbox-ativo', function (e) {
          self.callBackAtivo($(this).data('id'), this.checked, this);
        });

        $('#' + self.idTabela).on('click', 'input.checkbox-bloqueado', function (e) {
          self.callBackBloqueio($(this).data('id'), this.checked, this);
        });
      }

    });
  }

  onInclui(event){
    if(this.getPodeIncluir() && (UtilService.booleanNotNull(this.botaoIncluir.visible))){
      this.router.navigate([this.botaoIncluir.url]);
    }
  }

  isOcultaPainel(){
    return UtilService.booleanNotNull(this.ocultaPanel);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/tabeladatatables/tabeladatatables.component.ts